<template>

<div class="navbar">
      <div class="nav-content">
        <!-- CV Download Button -->
        <a href="/files/Brian_SWE.pdf" target="_blank" class="btn-cv" download>View CV</a>

        <!-- Hamburger Icon for mobile -->
        <div class="hamburger" @click="toggleMenu">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>

        <!-- Navigation Links -->
        <ul :class="{ 'nav-menu': true, 'active': menuActive }">
          <li><a href="#about" class="nav-link" @click.prevent="scrollToSection('aboutSection')">About</a></li>
          <li><a href="#services" class="nav-link" @click.prevent="scrollToSection('serviceSection')">Services</a></li>
          <li><a href="#timelime" class="nav-link" @click.prevent="scrollToSection('timelineSection')">History</a></li>
          <li><a href="#projects" class="nav-link" @click.prevent="scrollToSection('projectSection')">Projects</a></li>

          <li><a href="#contact" class="nav-link" @click.prevent="scrollToSection('contactSection')">Contact</a></li>
        </ul>
      </div>
    </div>
<div @scroll="handleScroll">

  <!-- <HeroSection ref="heroSection" id="heroSection"/> -->
  <AboutSection id="aboutSection"/>
  <ServicesSection id="serviceSection"/>
<TimelineSection id="timelineSection"/>
  <ProjectSection id="projectSection"/>
  <ContactSection id="contactSection"/>


    <div class="floating-dots" v-if="!isOnHeroSection && !isOnSmallScreen">
      <div v-for="(section, index) in sections" :key="index" 
           class="dot-container">
        <div :class="['dot', { active: isActive(section.id) }]"
             @mouseover="showSectionName(section.name)"
             @mouseleave="hideSectionName"
             @click="scrollToSection(section.id)">
        </div>
        <div class="section-name" v-if="hoveredSection === section.name">
          {{ section.name }}
        </div>
      </div>
  
  </div>
    <!--
  <nav class="navbar" v-if="isOnSmallScreen && !isOnHeroSection">
      <ul>
        <li v-for="(section, index) in sections" :key="index">
          <a :href="'#' + section.id">{{ section.name }}</a>
        </li>
      </ul>
  </nav> -->


</div>

<footer>
    <p>&copy; 2025 Brian Mulei. All rights reserved.</p>
  </footer>
</template>

<script>

//import HeroSection from '@/components/HeroSection.vue';
import AboutSection from '@/components/AboutSection.vue';
import ServicesSection from '@/components/ServicesSection.vue';
import TimelineSection from '@/components/TimelineSection.vue';

import ProjectSection from '@/components/ProjectSection.vue';
import ContactSection from '@/components/ContactSection.vue';
import { ref } from 'vue';

export default({

  components:{
   // HeroSection,
    AboutSection,
    ServicesSection,
    TimelineSection,
    ProjectSection,
    ContactSection
  },
  data() {
    return {
      menuActive: false, // Menu active state for mobile

      hoveredSection: '',
      sections: [
        { id: 'heroSection', name: 'Intro' },
        { id: 'aboutSection', name: 'About' },
        {id: 'serviceSection', name:'Services'},
        {id: 'timelineSection', name:'History'},
        {id: 'projectSection', name:'Projects'},
        {id: 'contactSection', name:'Contact '}
        // Add more sections as needed
      ],
      isOnHeroSection: true,
      isOnSmallScreen: window.innerWidth <= 768,
      activeSection: '',
      currentYear:ref(new Date().getFullYear),


    };
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive; // Toggle the menu on mobile
    },
    showSectionName(name) {
      this.hoveredSection = name;
    },
    hideSectionName() {
      this.hoveredSection = '';
    },
    scrollToSection(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
      this.menuActive = false; // Close the menu after clicking on mobile

    },
    handleScroll() {
      const heroSection = this.$refs.heroSection;
      const heroSectionRect = heroSection.$el.getBoundingClientRect();
      this.isOnHeroSection = heroSectionRect.bottom > 50;

      this.sections.forEach(section => {
        const element = document.getElementById(section.id);
        if (element) {
          const rect = element.getBoundingClientRect();
          const isInView = rect.top <= window.innerHeight && rect.bottom >= 0;
          if (isInView) {
            this.activeSection = section.id;
          }
        }
      });


    }
  },
  computed: {
    isActive() {
      return (sectionId) => this.activeSection === sectionId;
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Initial check
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
     handleResize() {
      this.isOnSmallScreen = window.innerWidth <= 768;
    }
  
})


</script>


<style scoped>
.app-container {
  position: relative;
}

.floating-dots {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
 
  z-index: 1000; /* Ensure it's above other content */
  animation: fadeInScaleUp 1s ease-out; /* Apply the animation here */

}

.dot-container {
  position: relative;
  margin-bottom: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
}
.dot.active {
  background-color: darkblue; /* Highlight the active dot */
}


.section-name {
  position: absolute;
  right: 20px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  top: -20px;
  white-space: nowrap;
}

.navbar {
  display: none;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: linear-gradient(45deg, #6a00f4, #00f4ff); /* Gradient from the hero section */
  color: white;
  padding: 10px;
  display: flex;
  justify-content: center;
  z-index: 1000; /* Ensure it's above other content */
}

.navbar ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.navbar li {
  margin: 0 15px;
}

.navbar a {
  color: white;
  text-decoration: none;
}

.navbar a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .floating-dots {
    display: none;
  }

  .navbar {
    display: block;
  }
}

/* Keyframes for fade-in and scale-up animation */
@keyframes fadeInScaleUp {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}


footer {
  padding-top: 2%;
  text-align: center;
  padding: 1em 0;
  background: linear-gradient(45deg, #6a00f4, #00f4ff); /* Gradient from the hero section */
  color: white;
}

.navbar {
  position: sticky;
  top: 0;
  width: 100%;
  background-color: #505050; /* Teal */
 
  align-items: center;
  padding: 1%;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.nav-link {
  color: #f5f5f5;
  font-family: 'Roboto', sans-serif;
  margin: 0 1rem;
  text-decoration: none;
  font-size: 1.1rem;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #ffffff;
}

.btn-cv {
  padding: 0.5rem 1rem;
  background-color: #00ffff85; /* Example color */
  color: #000000;
  text-decoration: none;
  border-radius: 5px;

  transition: background-color 0.3s;
}

 
/* Hamburger Menu Styles */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.hamburger .bar {
  width: 25px;
  height: 3px;
  background-color: white;
  margin: 4px 0;
  transition: 0.4s;
}

/* Navigation Links for Desktop */
ul.nav-menu {
  display: flex;
  list-style: none;
}

ul.nav-menu li {
  margin: 0 1rem;
}

/* Hide Navbar Links on Mobile by default */
ul.nav-menu.active {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #00f4ff;
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

ul.nav-menu.active li {
  margin: 0.5rem 0;
}

/* Responsive Navbar (Mobile) */
@media (max-width: 768px) {
  .hamburger {
    display: flex; /* Show the hamburger on mobile */
  }

  ul.nav-menu {
    display: none; /* Hide the nav menu on mobile */
  }

  ul.nav-menu.active {
    display: flex; /* Show when active on mobile */
  }
}

</style>
